// Exact SQL and Python contract. Values retain their units at every boundary.
export const ROUNDING_MODES = Object.freeze(['none', 'cent', 'five_cents', 'ten_cents', 'euro']);

export const engineRoundingMode = (mode = 'cent') => {
  if (!ROUNDING_MODES.includes(mode)) {
    throw Object.assign(new Error('Mode d’arrondi invalide. Sélectionnez une valeur du contrat de devis.'), {
      code: 'QUOTE_ROUNDING_MODE_INVALID',
    });
  }
  return mode;
};
